// Don't use nested object in this file.
export default {
  App: "/",
  Example: "/example",
  SignIn: "/sign-in",
  Forbidden: "/forbidden",

  // Master Data
  MasterData: "master-data",
  Currency: "master-data/currency",
  Country: "master-data/country",
  Province: "master-data/province",
  District: "master-data/district",
  Ward: "master-data/ward",
  PITRate: "master-data/pit-rate",
  RegionalMinimumWage: "master-data/regional-minimum-wage",
  Insurance: "master-data/insurance",
  Timezone: "master-data/timezone",
  Bank: "master-data/bank",
  Ethnicity: "master-data/ethnicity",

  // Payroll Settings
  LeavePolicy: "settings/leave-policy",
  Holiday: "settings/holiday",
  LeaveType: "settings/leave-type",
  Allowance: "settings/allowance",
  WorkShift: "settings/work-shift",
  Compensation: "settings/compensation-package",
  PayrollTemplate: "settings/payroll-template",
  Earning: "settings/earning",
  BenefitsInKind: "settings/benefits-in-kind",
  OTRate: "settings/ot-rate",
  Deduction: "settings/deduction",
  ApprovalWorkflow: "settings/approval-workflow",
  CompanySetting: "settings/company-setting",
  EmailTemplate: "settings/email-template",
  PayslipTemplate: "settings/payslip-template",

  // Company
  Company: "/company",
  CompanyInfo: "/company/info",
  WorkLevel: "/company/work-level",
  KPISetting: "/company/kpi-setting",

  ContractType: "/company/contract-type",
  Department: "/company/department",
  Branch: "/company/branch",
  Title: "/company/title",
  OrgChart: "/company/org-chart",
  RoleAndPermission: "/company/role-and-permission",
  RoleDetail: "/company/role-and-permission/role",
  GroupEmployeeDetail: "/company/role-and-permission/group-employee",
  PayrollCycle: "/company/payroll-cycle",

  Employee: "/employee",
  EmployeeDetail: "/employee",
  EmployeeCreate: "/employee/create",

  PayrollManagement: "/payroll-management",
  TimeAttendance: "/payroll-management/time-attendance",
  RunPayroll: "/payroll-management/run-payroll",
  Payroll: "/payroll-management/payroll",
  SalaryAdvance: "/payroll-management/salary-advance",
  SalaryAdvanceDetail: "/payroll-management/salary-advance",
  SalaryPaymentDetail: "/payroll-management/salary-payment",

  Report: "/report",
  ReportTimesheet: "/report/timesheet",
  ReportReconcile: "/report/reconcile",
  ReportPayrollSummary: "/report/payroll-summary",
  ReportSHUIContribution: "/report/shui-contribution",
  ReportPITSummary: "/report/pit-summary",
  ReportOneStream: "/report/one-stream",
  ReportEmployeeProfile: "/report/employee-profile",
  ReportDiligence: "/report/diligence",
  MyReport2: "/report/my-report-2",
  MyReport3: "/report/my-report-3",
  MyReport4: "/report/my-report-4",
  MyReport5: "/report/my-report-5",
  MyReport6: "/report/my-report-6",

  // Product activity
  PAMasterData: "/pa",
  PAMachine: "/pa/machine",
  PAProduct: "/pa/product",
  PAMachineGroup: "/pa/group-machine",
  PAReasonStop: "/pa/reason-stop",
  PAStandardQuantity: "/pa/standard-quantity",
  PATemplate: "/pa/template",
  PAEmployee: "/pa/pa-employee",
  PAProductionLogs: "/pa/pa-production-logs",
  PAMachineDowntime: "/pa/pa-machine-downtime",
  PAOTWithoutMachineOperations: "/pa/pa-ot-without-machine-operations",
  PARunProductivity: "/pa/pa-run-productivity",
  PAProductivitySalary: "/pa/pa-productivity",
  PAProductivitySalarySummary: "/pa/pa-summary-productivity",
  Report13thMonthSalary: "/13th-month-salary",

  TimeOff: "/time-off",
  Adjustment: "/adjustment",

  PIT: "/pit",

  AuditLog: "/audit-log",
  KPIIndividual: "/kpi-individual",
  KPIDepartment: "/kpi-department",
} as const;
